import store from '../../store';
import { siteId, salesChannelId } from '../../config';
import { getEventsRecommendationId } from '../../reducers/events/byId';

export const fromNewSession = props => ({
  sessionId: props.SessionId,
});

export const toViewTicket = ({ ticket, quantity }) => ({
  SalesChannelId: salesChannelId,
  Recommendation: getEventsRecommendationId(ticket.tgClientData.eventId)(store.getState()),
  TicketId: ticket.tgID,
  Section: ticket.tgUserSec,
  Row: ticket.tgUserRow,
  Quantity: quantity,
  SalePrice: ticket.tgPrice,
  SiteId: siteId,
  // UserId: ticket.userId,
});

export const toBuyTicket = ({ ticket, quantity }) => ({
  SalesChannelId: salesChannelId,
  Recommendation: getEventsRecommendationId(ticket.tgClientData.eventId)(store.getState()),
  TicketId: ticket.tgID,
  Section: ticket.tgUserSec,
  Row: ticket.tgUserRow,
  Quantity: quantity,
  SalePrice: ticket.tgPrice,
  SiteId: siteId,
  // UserId: ticket.userId,
});

export const toAction = ({ actiontype, action, actiondata }) => ({
  Action : action,
  ActionData: actiondata,
  ActionType: actiontype,
});


// WEBPACK FOOTER //
// ./src/resources/analytics/normalizers.js